/// <reference types="./ContentNormalizer.d.ts" />
import { IDENTITY_TRANSFORMER, transformComponent, transformContentField, transformEntityFields, } from './ContentTransformer.js';
export function normalizeEntityFields(schema, path, entity, options) {
    return transformEntityFields(schema, [...path, 'fields'], entity, IDENTITY_TRANSFORMER, options);
}
export function normalizeComponent(schema, path, component, options) {
    return transformComponent(schema, path, component, IDENTITY_TRANSFORMER, options);
}
export function normalizeContentField(schema, path, fieldSpec, value, options) {
    return transformContentField(schema, path, fieldSpec, value, IDENTITY_TRANSFORMER, options);
}
//# sourceMappingURL=ContentNormalizer.js.map